<template>
  <ul class="c-suggestList">
    <li
      v-for="(suggest,index) in suggests"
      :key="`suggest_${index}`"
      v-on:mouseover="onMouseOver(index)"
      v-on:mouseleave="onMouseLeave"
      class="c-suggestList_item"
      :class="{'c-suggestList_item-focused':isFocused(index)}"
      @click="select(index)"
      v-html="emphasizeKeyword(suggest)"
    />
  </ul>
</template>
<script>
export default {
  name: 'SuggestList',
  props: {
    searchText: {
      type: String,
      default: ''
    },
    focusedIndex: {
      type: Number,
      default: null
    },
    suggests: {
      type: Array,
      default: () => [],
      validator(suggests) {
        let isIncludeAllNeedKey = true
        suggests.forEach(suggest => {
          const requiredKeyList = ['title', 'masterCategoryId', 'masterCategoryName', 'type']
          const valueKeys = Object.keys(suggest)
          requiredKeyList.forEach(needKey => {
            isIncludeAllNeedKey = isIncludeAllNeedKey && valueKeys.includes(needKey)
          })
        })
        return isIncludeAllNeedKey
      }
    }
  },

  methods: {
    select(index) {
      this.$emit('select', this.suggests[index])
    },
    emphasizeKeyword(suggest) {
      const suggestWords = suggest.title.split(' ')
      // NOTE:半角と全角のスペースを文字コードで指定してやる必要がある
      const searchWords = this.searchText.split(/[\x20\u3000]/)
      const keywords = suggestWords.map(str => {
        if (searchWords.includes(str)) {
          return `<span class="c-emphasis">${str}</span><span class="c-suggestList_itemIcon"><i class="coconala-icon -chevron-right"></i></span>`
        }
        return str
      })
      if (suggest.type === 'category') {
        return (
          '<span class="c-suggestList_itemTitle">' +
          keywords.join(' ') +
          '</span>' +
          '<span class="c-suggestList_itemCategory">' +
          suggest.masterCategoryName +
          '</span><span class="c-suggestList_itemIcon"><i class="coconala-icon -chevron-right"></i></span>'
        )
      }
      return keywords.join(' ')
    },
    isFocused(index) {
      return this.focusedIndex === index
    },
    onMouseOver(index) {
      this.$emit('focus', index)
    },
    onMouseLeave() {
      this.$emit('focusOut')
    }
  }
}
</script>
<style lang="scss" scoped>
.c-suggestList {
  &_item {
    padding: 6px 14px;
    font-weight: bold;
    &-focused {
      background-color: $color-gray-50;
      cursor: pointer;
    }
  }
}

/deep/ .c-suggestList {
  &_itemTitle {
    color: $ds2-color-gray-900;
  }

  &_itemCategory {
    display: block;
    color: $ds2-color-gray-400;
    font-weight: normal;
    font-size: 11px;
    line-height: 16px;
  }

  &_itemIcon {
    display: none;
  }
}

/deep/ .c-emphasis {
  font-weight: normal;
}

@media (max-width: breakpoint(Header, S)) {
  .c-suggestList {
    &_item {
      position: relative;
      border-bottom: 1px solid $ds2-color-gray-100;
    }
  }

  /deep/ .c-suggestList {
    &_itemIcon {
      position: absolute;
      top: 13px;
      right: 21px;
      display: block;
      color: $ds2-color-gray-600;
      font-size: 12px;
    }
  }
}
</style>
